export class RouterPathParamValueNotFoundException extends Error {
  constructor(message: string) {
    super(message);
  }
}
